// extracted by mini-css-extract-plugin
module.exports = {"paramRow":"IntervalDetailDialog_paramRow__3tRIt","check":"IntervalDetailDialog_check__1AQM3"};